import { GenericResponse } from "src/app/shared/interface/generic.interface";
import { Notification } from "../interface/notification.interface";

export const mapNotification = (
  response: GenericResponse<Notification[]>
) => {
  return {
    ...response,
    data: response.data.map(item => ({
      ...item,
      sMensaje: typeof item.sMensaje === 'string' ? JSON.parse(item.sMensaje) : item.sMensaje,
      sLink_Notificacion: typeof item.sLink_Notificacion === 'string' ? JSON.parse(item.sLink_Notificacion) : item.sLink_Notificacion,
      dFecha_Creacion: typeof item.dFecha_Creacion === 'string' ? new Date(item.dFecha_Creacion) : item.dFecha_Creacion
    }))
  };
};